<template>
    <div>
        <result-message
            v-if="item && Number(item.status) === 5"
            type="success"
            title="Ca test đã được hủy lịch!"
        >
            <p>Người hủy lịch: {{ getCanceler(testInputScheduleItem) }}</p>
            <p>
                Thời gian:
                {{ testInputScheduleItem.canceled_at || testInputScheduleItem.time_confirm }}.
            </p>
        </result-message>

        <result-message
            v-else-if="isConfirmed"
            type="success"
            title="Ca test đã được xác nhận!"
        >
            <p>
                Người xác nhận:
                {{ getUserLabel(testInputScheduleItem.user_created) }}
            </p>
            <p>Thời gian: {{ testInputScheduleItem.time_confirm }}.</p>
        </result-message>

        <result-message
            v-else-if="item && item.status"
            type="error"
            title="Ca test đã hết hiệu lực xác nhận!"
        />

        <div v-else class="notification-loading">
            <span class="notification-spinner"></span>
        </div>
    </div>
</template>

<script>
import ResultMessage from "./ResultMessage.vue";

export default {
    name: "Notification",
    components: { ResultMessage },
    props: {
        item: {
            type: Object,
            default: null,
        },
        testInputScheduleItem: {
            type: Object,
            default: null,
        },
    },
    computed: {
        isConfirmed() {
            const item = this.testInputScheduleItem;
            return item && Number(item.is_confirm_come_test) === 1 && Number(item.status) !== 4;
        },
    },
    methods: {
        getUserLabel(user) {
            if (!user) {
                return "";
            }

            return `${Number(user.id) + 100000} - ${user.name}`;
        },
        getCanceler(testInputScheduleItem) {
            if (!testInputScheduleItem) {
                return "";
            }

            if (testInputScheduleItem.canceller) {
                return this.getUserLabel(testInputScheduleItem.canceller);
            }

            return this.getUserLabel(testInputScheduleItem.user_created);
        },
    },
};
</script>

<style scoped>
.notification-loading {
    display: flex;
    justify-content: center;
    padding: 16px 0;
}

.notification-spinner {
    width: 32px;
    height: 32px;
    border: 4px solid rgba(101, 85, 143, 0.2);
    border-top-color: #65558f;
    border-radius: 50%;
    animation: notification-spin 0.8s linear infinite;
}

@keyframes notification-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>